import { render, staticRenderFns } from "./Advantage.vue?vue&type=template&id=23e68f98&scoped=true"
import script from "./Advantage.vue?vue&type=script&lang=js"
export * from "./Advantage.vue?vue&type=script&lang=js"
import style0 from "../../css/newProjectDetail.css?vue&type=style&index=0&id=23e68f98&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23e68f98",
  null
  
)

export default component.exports